var ItemWarningsService = /** @class */ (function () {
    function ItemWarningsService($http, $q) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
    }
    ItemWarningsService.prototype.getItemWarnings = function (itemWarningRequest) {
        itemWarningRequest['cache'] = true;
        return this.$http.post('api/products/itemWarnings', itemWarningRequest);
    };
    return ItemWarningsService;
}());
export default ItemWarningsService;
//# sourceMappingURL=item-warnings.service.js.map